import React from 'react';
import { X } from 'lucide-react';
import { useTouchHandler } from '../../hooks/useTouchHandler';
import './BottomSheetModal.css';

/**
 * Unified bottom sheet modal component
 * Adapts to mobile (bottom sheet) and desktop (centered modal) automatically
 */
const BottomSheetModal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  maxHeight = '80vh',
  className = '',
  showCloseButton = true,
  showGripper = true
}) => {
  const { handleTouchStart, handleTouchMove, handleTouchEnd } = useTouchHandler(onClose);
  
  if (!isOpen) return null;
  
  return (
    <>
      <div className="modal-backdrop show" onClick={onClose} />
      <div 
        className={`bottom-sheet-modal ${className} show`}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{ maxHeight }}
      >
        {showGripper && (
          <div className="modal-gripper">
            <div className="gripper-line"></div>
          </div>
        )}
        
        <div className="modal-header">
          {title && <h3 className="modal-title">{title}</h3>}
          {showCloseButton && (
            <button onClick={onClose} className="modal-close">
              <X className="close-icon" />
            </button>
          )}
        </div>
        
        <div className="modal-content">
          {children}
        </div>
      </div>
    </>
  );
};

export default BottomSheetModal; 